import dayjs from 'dayjs';

export const getDividerText = (timestamp: string) => {
  const now = dayjs();
  const date = dayjs(timestamp);
  const yearsDifference = now.diff(date, 'year');

  if (now.isSame(date, 'day')) {
    return 'Today';
  }

  if (now.subtract(1, 'day').isSame(date, 'day')) {
    return 'Yesterday';
  }

  return dayjs(timestamp).format(`MMMM D${yearsDifference ? ', YYYY' : ''}`);
};

export const getAvatarFallbackText = (name: string) => {
  const splitName = name.split(' ');

  if (!splitName.length) {
    return '';
  }

  let fallback = splitName[0][0];

  if (splitName[1]) {
    fallback += splitName[1][0];
  }

  return fallback?.toUpperCase() ?? '';
};
